import SvgIcon from 'LuxKit/SvgIcon'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import LineMountainsSunIcon from 'LuxKit/Icons/line/LineMountainsSunIcon'
import LineUserPlusIcon from 'LuxKit/Icons/line/LineUserPlusIcon'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import LineBoltAltIcon from 'LuxKit/Icons/line/LineBoltAltIcon'
import LineBullseyeIcon from 'LuxKit/Icons/line/LineBullseyeIcon'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineGlobeIcon from 'LuxKit/Icons/line/LineGlobeIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineUltraLuxDiamondIcon from 'LuxKit/Icons/line/LineUltraLuxDiamondIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineIslandIcon from 'LuxKit/Icons/line/LineIslandIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineStopwatchIcon from 'LuxKit/Icons/line/LineStopwatchIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineHomeAltIcon from 'LuxKit/Icons/line/LineHomeAltIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import SolidPlusIcon from 'LuxKit/Icons/solid/SolidPlusIcon'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineLightbulbIcon from 'LuxKit/Icons/line/LineLightbulbIcon'

const iconMap: Record<string, typeof SvgIcon> = {
  star: SolidStarIcon,
  search: LineSearchIcon,
  'mountains-sun': LineMountainsSunIcon,
  gift: LineGiftIcon,
  'user-plus': LineUserPlusIcon,
  'plane-departure': LinePlaneDepartureIcon,
  ticket: LineTicketIcon,
  'tag-alt': LineTagAltIcon,
  'bolt-alt': LineBoltAltIcon,
  bulleyse: LineBullseyeIcon,
  user: LineUserIcon,
  globe: LineGlobeIcon,
  'line-star': LineStarIcon,
  'hot-air-balloon': LineHotAirBalloonIcon,
  'ultra-lux-diamond': LineUltraLuxDiamondIcon,
  island: LineIslandIcon,
  ship: LineShipIcon,
  compass: LineCompassIcon,
  bed: LineBedIcon,
  stopwatch: LineStopwatchIcon,
  car: LineCarIcon,
  'home-alt': LineHomeAltIcon,
  heart: LineHeartIcon,
  plus: SolidPlusIcon,
  shop: LineShopIcon,
  usd: LineUsdCircleIcon,
  lightbulb: LineLightbulbIcon,
}

export const getNavigationMenuIcon = (name: string) => iconMap[name]
